<template>
  <swiper
    ref="swiperComponent"
    class="vue-carousel"
    :options="swiperOptions"
  >
    <swiper-slide
      v-for="(slide, index) in slides"
      :key="index"
    >
    <template v-if="slides.length === 1">
      <div class="slide-content is-active">
        <div class="slide-title">
          {{ slide.title }}
        </div>
        <div class="slide-image">
          <img :src="getImage(slide.thumb)">
        </div>
        <div
          class="slide-description"
          v-html="slide.description"
        />
      </div>
    </template>
    <template v-else>
      <div
        :class="['slide-content', {'is-active': index === currentSliderIndex}]"
        @click="currentSliderIndex = index"
      >
        <div class="slide-title">
          {{ slide.title }}
        </div>
        <div class="slide-image">
          <img :src="getImage(slide.thumb)">
        </div>
        <div
          class="slide-description"
          v-html="slide.description"
        />
      </div>
    </template>

    </swiper-slide>
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
const noimage = require('@/assets/images/slide_noimage.svg');

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiper: null,
      swiperOptions: {
        slidesPerView: 4.6,
      },
      intervalTimer: null,
    };
  },
  computed: {
    slides: ({ $store }) => $store.state.homeNavigator.slides,
    currentSliderIndex: {
      get: ({ $store }) => $store.state.homeNavigator.currentSliderIndex,
      set(index) {
        this.$store.commit('homeNavigator/switchCurrentSlideIndex', index);
      },
    },
    slideTimer: ({ $store }) => $store.state.homeNavigator.slideTimer,
  },
  watch: {
    currentSliderIndex(value) {
      this.swiper.slideTo(value);
    },
  },
  mounted() {
    this.swiper = this.$refs.swiperComponent.swiper;
  },
  methods: {
    getImage: (image) => image || noimage,
  },
};
</script>

<style scoped lang="scss">
.slide {
  &-content {
    position: relative;
    width: 244px;
    height: 164px;
    &.is-active:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 4px solid #e54a2b;
    }
  }
  &-title {
    box-sizing: border-box;
    height: 27px;
    padding-left: 7px;
    border-bottom: 1px solid #707070;
    background: #fff;
    line-height: 27px;
    font-size: 12px;
    font-weight: bold;
    color: #5e5e5d;
    background-image: url('~@/assets/images/icon_arrow.svg');
    background-repeat: no-repeat;
    background-position: top 50% right 11px;
    background-size: 12px 12px;
  }
  &-image {
    width: 244px;
    height: 137px;
  }
  &-description {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 8px 22px;
    background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 100%);
    text-align: right;
    font-size: 10px;
    font-weight: bold;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// slider.vue?5461e050